import { render, staticRenderFns } from "./images-tab.vue?vue&type=template&id=7025279a&scoped=true"
import script from "./images-tab.vue?vue&type=script&lang=js"
export * from "./images-tab.vue?vue&type=script&lang=js"
import style0 from "./images-tab.vue?vue&type=style&index=0&id=7025279a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7025279a",
  null
  
)

export default component.exports